import assign from '../assign/index.js';
export default function cloneObject(dirtyObject) {
  return assign({}, dirtyObject);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/date-fns/esm/_lib/cloneObject/index.js
// module id = 157
// module chunks = 0